module.exports = __webpack_public_path__ + "img/banner3.86d53d87.png";